const commonDrawJs = {

}
commonDrawJs.drawLine = function (ctx, line, color, lineWidth, lineDash) {
  if (ctx === null || line === null) {
    return
  }

  ctx.save()
  ctx.strokeStyle = color
  ctx.lineWidth = lineWidth
  ctx.setLineDash(lineDash || [0])
  ctx.beginPath()
  ctx.moveTo(line.x1, line.y1)
  ctx.lineTo(line.x2, line.y2)
  ctx.stroke()
  ctx.restore()
}
commonDrawJs.drawLines = function (ctx, points, color, lineWidth, lineDash) {
  if (ctx === null || points === null) {
    return
  }
  ctx.save()
  ctx.strokeStyle = color
  ctx.lineWidth = lineWidth
  ctx.setLineDash(lineDash || [0])
  ctx.beginPath()
  ctx.moveTo(points[0].x, points[0].y)
  for (var i = 1; i < points.length; i++) {
    ctx.lineTo(points[i].x, points[i].y)
  }
  ctx.lineTo(points[0].x, points[0].y)
  ctx.stroke()
  ctx.restore()
}
commonDrawJs.drawRect = function (ctx, x, y, width, height, color, fillColor, lineWidth, isFill) {
  if (ctx === null) {
    return
  }

  ctx.save()
  if (isFill) {
    ctx.fillStyle = fillColor
    ctx.fillRect(x, y, width, height)
  }
  ctx.strokeStyle = color
  ctx.strokeRect(x, y, width, height)
  ctx.lineWidth = lineWidth
  ctx.restore()
}
commonDrawJs.drawPath = function (ctx, points, color) {
  var i, p

  if (ctx === null || points === null) {
    return
  }

  ctx.save()
  ctx.beginPath()
  for (i = 0; i < points.length; i++) {
    p = points[i]
    ctx.lineTo(p.x, p.y)
  }
  ctx.closePath()
  ctx.fillStyle = color
  ctx.fill()
  ctx.restore()
}
commonDrawJs.drawText = function (ctx, text, x, y, color) {
  if (ctx === null) {
    return
  }

  ctx.save()
  ctx.font = '14px Arial'
  ctx.textAlign = 'center'
  ctx.textBaseline = 'bottom'
  ctx.fillStyle = color
  ctx.fillText(text, x, y)
  ctx.restore()
}
commonDrawJs.toPoint = (x, y) => {
  return {
    x: x,
    y: y
  }
}
commonDrawJs.toRect = (x, y, width, height) => {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  }
}
commonDrawJs.toLine = (x1, y1, x2, y2, color, lineWidth) => {
  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    color: color,
    lineWidth: lineWidth || 1
  }
}
commonDrawJs.toArrow = (x1, y1, x2, y2, x3, y3, color) => {
  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    x3: x3,
    y3: y3,
    color: color
  }
}
commonDrawJs.toText = (x, y, text, position) => {
  return {
    text: text,
    x: x,
    y: y,
    position: position
  }
}
export default commonDrawJs
